export enum AlertType {
  ERROR,
  SUCCESS,
  WARNING,
}
